import { findDOMNode } from 'react-dom';
import { getStringLength } from '../../../utils/getStringLength.js';

const GHOST_ITEM_KEY = '__rc_ghost_item__';
function getLocationItem(scrollPtg, total) {
  const itemIndex = Math.floor(scrollPtg * total);
  const itemTopPtg = itemIndex / total;
  const offsetPtg = (scrollPtg - itemTopPtg) / (1 / total);
  return {
    index: itemIndex,
    // scrollPtg >= itemTopPtg
    offsetPtg: Number.isNaN(offsetPtg) ? 0 : offsetPtg
  };
}

/**
 * Get HTML element height
 */
function getNodeHeight(node) {
  const element = findDOMNode(node);
  return element ? element.offsetHeight : 0;
}

/**
 * Safari scrollTop
 */
function getValidScrollTop(scrollTop, scrollRange) {
  const scrlTop = scrollTop > scrollRange ? scrollRange : scrollTop;
  return scrollTop < 0 ? 0 : scrlTop;
}
function getScrollPercentage({
  scrollTop,
  scrollHeight,
  clientHeight
}) {
  const scrollRange = scrollHeight - clientHeight;
  return scrollRange <= 0 ? 0 : getValidScrollTop(scrollTop, scrollRange) / scrollRange;
}

/**
 * Calculate the start subscript, end subscript and element subscript for positioning of the element to be rendered
 */
function getRangeIndex(scrollPtg, itemCount, visibleCount) {
  const {
    index,
    offsetPtg
  } = getLocationItem(scrollPtg, itemCount);
  const beforeCount = Math.ceil(scrollPtg * visibleCount);
  const afterCount = Math.ceil((1 - scrollPtg) * visibleCount);
  return {
    itemIndex: index,
    itemOffsetPtg: offsetPtg,
    startIndex: Math.max(0, index - beforeCount),
    endIndex: Math.min(itemCount - 1, index + afterCount)
  };
}
/**
 * Calculate the offset of the element relative to the top of the viewport
 */
function getItemRelativeTop({
  itemHeight,
  itemOffsetPtg,
  scrollPtg,
  clientHeight
}) {
  return Math.floor(clientHeight * scrollPtg - itemHeight * itemOffsetPtg);
}

/**
 * Calculate the offset of the element relative to the top of the entire scroll area
 */
function getItemAbsoluteTop({
  scrollTop,
  ...rest
}) {
  return scrollTop + getItemRelativeTop(rest);
}
/**
 * Calculates the offset of an element at a specified index relative to the top of the viewport
 */
function getCompareItemRelativeTop({
  locatedItemRelativeTop,
  locatedItemIndex,
  compareItemIndex,
  startIndex,
  endIndex,
  getItemKey,
  itemElementHeights,
  itemHeight
}) {
  let compareItemTop = locatedItemRelativeTop;
  const compareItemKey = getItemKey(compareItemIndex);
  if (compareItemIndex <= locatedItemIndex) {
    for (let index = locatedItemIndex; index >= startIndex; index -= 1) {
      const key = getItemKey(index);
      if (key === compareItemKey) {
        break;
      }
      const prevItemKey = getItemKey(index - 1);
      compareItemTop -= itemElementHeights[prevItemKey] || itemHeight;
    }
  } else {
    for (let index = locatedItemIndex; index <= endIndex; index += 1) {
      const key = getItemKey(index);
      if (key === compareItemKey) {
        break;
      }
      compareItemTop += itemElementHeights[key] || itemHeight;
    }
  }
  return compareItemTop;
}
function getLongestItemIndex(data) {
  let result = -1;
  let length = 0;
  data.forEach((item, index) => {
    item = typeof item === 'string' ? item : item.props?.children;
    if (typeof item === 'string') {
      const _length = getStringLength(item);
      if (_length > length) {
        length = _length;
        result = index;
      }
    }
  });
  return result;
}

export { GHOST_ITEM_KEY, getCompareItemRelativeTop, getItemAbsoluteTop, getItemRelativeTop, getLocationItem, getLongestItemIndex, getNodeHeight, getRangeIndex, getScrollPercentage, getValidScrollTop };
